import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Icon from '../../Components/Icons/Icon';
import { classNames, useNewWindow } from '../../Services/helpers';

const Socials = () => {

    return (
        <>
            <TopBar left="BackBtn" title="getSocial" />
            <Page>
                <div className="prose mb-5">
                    <p>
                        We often post tips and tricks on our social media pages.
                    </p>

                    <p>
                        Follow us to stay up to date, and feel free to ask us any questions.
                    </p>
                </div>

                <Link title="facebook.com/getSoapyApp"
                    href="https://www.facebook.com/getSoapyApp"
                    icon="Facebook"
                />
                <Link title="youtube.com/@getSoapy"
                    href="https://www.youtube.com/@getSoapy"
                    icon="YouTube"
                />
                <Link title="google"
                    href="https://g.page/r/CSiF_6VyqCO6EBM/review"
                    icon="Google"
                />
                <Link title="instagram.com/getSoapyApp"
                    href="https://www.instagram.com/getsoapyapp"
                    icon="Instagram"
                />
                <Link title="twitter.com/getSoapy"
                    href="https://www.twitter.com/getSoapy"
                    icon="Twitter"
                />
                <Link title="mastodon.social/@getSoapy"
                    href="https://mastodon.social/@getSoapy"
                    icon="Mastodon"
                />
                <Link title="@getSoapy.bsky.social"
                    href="https://bsky.app/profile/getsoapy.bsky.social"
                    icon="Bluesky"
                />
                <Link title="trustpilot.com/review/getsoapy.co.uk"
                    href="https://uk.trustpilot.com/review/getsoapy.co.uk"
                    icon="TrustPilot"
                />

            </Page>
        </>
    )
}

const Link = ({title, href, icon}) => {
    const newWindow = useNewWindow();
    return <div className={classNames(
                'mb-3',
                'flex space-between',
                'p-2 rounded-lg border text-sm transition-colors',
                'bg-slate-100 text-slate-900'
            )}
            onClick={() => newWindow(href)}
        >
            <Icon theme="brands" icon={icon} size="2x" className="mr-2 shrink-0" />
            <span className="block break-all grow">
                {title}
            </span>
            <Icon theme="light" icon="LinkExternal" size="1x" className="ml-2 shrink-0" />
        </div>
}

export default Socials;
